export default class AnalyticsFireBase {
    constructor(AppName, Version) {
        this.AppName = AppName;
        this.Version = Version;
        this.DebugMode = false;
    }
    async trackPage(page) {
        var isCordovaApp = !!window.cordova;
        if (isCordovaApp) {
            if (typeof cordova == 'undefined' || typeof cordova.plugins == 'undefined' || typeof cordova.plugins.firebase == 'undefined') {
                console.error("cordova.plugins.firebase.analytics plugin is missing");
                return;
            }
            await cordova.plugins.firebase.analytics.setCurrentScreen(page);
        } else {
            //todo: add web version non sdk
            if (this.DebugMode)
                console.log("AnalyticsFireBase: TrackPage not set up for non SDK(web)");
        }


    };


    async trackEvent(name, params = {}) {
        var isCordovaApp = !!window.cordova;
        if (isCordovaApp) {
            if (typeof cordova == 'undefined' || typeof cordova.plugins == 'undefined' || typeof cordova.plugins.firebase == 'undefined') {
                console.error("cordova.plugins.firebase.analytics plugin is missing");
                return;
            }
            await cordova.plugins.firebase.analytics.logEvent(name, params);
            //await cordova.plugins.firebase.analytics.logEvent("my_event", {param1: "value1"});
        } else {
            //todo: add web version non sdk
            if (this.DebugMode)
                console.log("AnalyticsFireBase: TrackEvent not set up for non SDK(web)");
        }


    };

    async setUserProperty(name, value) {

        var isCordovaApp = !!window.cordova;
        if (isCordovaApp) {
            if (typeof cordova == 'undefined' || typeof cordova.plugins == 'undefined' || typeof cordova.plugins.firebase == 'undefined') {
                console.error("cordova.plugins.firebase.analytics plugin is missing");
                return;
            }
            await cordova.plugins.firebase.analytics.setUserProperty(name, value);
            //await cordova.plugins.firebase.analytics.setUserProperty("name1", "value1");
        } else {
            //todo: add web version non sdk
            if (this.DebugMode)
                console.log("AnalyticsFireBase: setUserProperty not set up for non SDK(web)");
        }
    }

}